import { unsafeCSS } from "lit"

export const DARKER_WHITE = "#fafafa"
export const LIGHT_BLACK = "rgba(0, 0, 0, 0.75)"
export const CHOCOLATE = "#341100"
export const CAPPUCINO = "#ede0db"
export const LIGHT_GREY = "#f0f0f0"
export const GREY = "#ccc"
export const BLUE = "#0064c8"
export const SUCCESS = "#8BC34A"
export const DANGER = "#FF5252"
export const LIGHT_RED = "#ffcccc"
export const LIGHT_GREEN = "#ccffcc"
export const GREEN = "#199654"

export const SAFE_DARKER_WHITE = unsafeCSS(DARKER_WHITE)
export const SAFE_LIGHT_BLACK = unsafeCSS(LIGHT_BLACK)
export const SAFE_CHOCOLATE = unsafeCSS(CHOCOLATE)
export const SAFE_CAPPUCINO = unsafeCSS(CAPPUCINO)
export const SAFE_LIGHT_GREY = unsafeCSS(LIGHT_GREY)
export const SAFE_GREY = unsafeCSS(GREY)
export const SAFE_BLUE = unsafeCSS(BLUE)
export const SAFE_SUCCESS = unsafeCSS(SUCCESS)
export const SAFE_DANGER = unsafeCSS(DANGER)
export const SAFE_LIGHT_RED = unsafeCSS(LIGHT_RED)
export const SAFE_LIGHT_GREEN = unsafeCSS(LIGHT_GREEN)
export const SAFE_GREEN = unsafeCSS(GREEN)
